const enMessages = {
    dropdowns: {
        nodata: 'No results found',
        clear: 'Clear',
        comboArrowBtnAriaLabelExpand: 'Open dropdown list',
        comboArrowBtnAriaLabelCollapse: 'Close dropdown list',
        dropDownListArrowBtnAriaLabel: 'Choose'
    }
}

export default enMessages